interface EventsFiltersProps {
  categories: string[];
  locations: string[];
  selectedCategory: string;
  selectedLocation: string;
  priceRange: string;
  dateFilter: string;
  onCategoryChange: (v: string) => void;
  onLocationChange: (v: string) => void;
  onPriceRangeChange: (v: string) => void;
  onDateFilterChange: (v: string) => void;
  onClearAll: () => void;
  hasActiveFilters: boolean;
}

const EventsFilters = ({
  categories,
  locations,
  selectedCategory,
  selectedLocation,
  priceRange,
  dateFilter,
  onCategoryChange,
  onLocationChange,
  onPriceRangeChange,
  onDateFilterChange,
  onClearAll,
  hasActiveFilters,
}: EventsFiltersProps) => {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-bold text-gray-900 flex items-center gap-2">
          <i className="ri-filter-3-line text-teal-600"></i>
          Filters
        </h3>
        {hasActiveFilters && (
          <button
            onClick={onClearAll}
            className="text-xs text-teal-600 hover:text-teal-700 font-medium cursor-pointer whitespace-nowrap flex items-center gap-1"
          >
            <i className="ri-close-circle-line"></i>
            Clear all
          </button>
        )}
      </div>

      <div className="space-y-4">
        {/* Category */}
        <div>
          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
            Category
          </label>
          <div className="flex flex-wrap gap-2">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => onCategoryChange(cat)}
                className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
                  selectedCategory === cat
                    ? 'bg-teal-500 text-white shadow-sm'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* Date */}
        <div>
          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
            Date
          </label>
          <div className="flex flex-wrap gap-2">
            {['All', 'Today', 'This Week', 'This Month'].map((d) => (
              <button
                key={d}
                onClick={() => onDateFilterChange(d)}
                className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
                  dateFilter === d
                    ? 'bg-teal-500 text-white shadow-sm'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {d}
              </button>
            ))}
          </div>
        </div>

        {/* Price */}
        <div>
          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
            Price
          </label>
          <div className="flex gap-2">
            {['All', 'Free', 'Paid'].map((p) => (
              <button
                key={p}
                onClick={() => onPriceRangeChange(p)}
                className={`flex-1 py-1.5 rounded-full text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
                  priceRange === p
                    ? 'bg-teal-500 text-white shadow-sm'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {p}
              </button>
            ))}
          </div>
        </div>

        {/* Location */}
        <div>
          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
            Location
          </label>
          <select
            value={selectedLocation}
            onChange={(e) => onLocationChange(e.target.value)}
            className="w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg text-sm text-gray-800 focus:outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20 transition-all cursor-pointer"
          >
            {locations.map((loc) => (
              <option key={loc} value={loc}>
                {loc}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default EventsFilters;
